import { Store } from '@ngrx/store';
import { Flow_0_0_2, getFullItemTwo, BigFormService, getSubmissionData } from '@flexus/core';
import { CollapseActionPanel, setActionPanelItems } from '../../../app-shell-features';

import { forkJoin } from 'rxjs';
import { skipWhile, map, take, switchMap } from 'rxjs/operators';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { environment } from 'apps/studio/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';

export const SP_GLOBAL_201: Flow_0_0_2 = {
	id: '201',
	name: 'replacement_stock_arrived_set_new_appointment',
	itemType: 'flow',
	actionPanel: instance => setActionPanelItems(instance, ['job-details', 'notes', 'documents']),
	onStateInit: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	header: {
		title: (_store: Store, _bf: BigFormService) => {
			return _store.select(getFullItemTwo).pipe(
				map((itemTwo: any) => {
					if (itemTwo) {
						let claimref;
						if (itemTwo?.claim?.applicant && itemTwo?.claim?.loan_information) {
							if (itemTwo?.claim?.loan_information?.mavenclaimnumber) {
								claimref = itemTwo?.claim?.loan_information?.mavenclaimnumber;
							} else {
								claimref = itemTwo?.claim?.loan_information?.voucher_key;
							}
							return `Replacement Stock Arrived - Set New Appointment: ${claimref} - ${itemTwo?.claim?.applicant?.first_name}`;
						} else {
							return 'Replacement Stock Arrived - Set New Appointment';
						}
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	serverCalls: {
		skills: {
			serviceVariable: 'spService',
			functionName: 'getSkills',
			responseSlice: 'skills',
			errorMessage: 'No skills were found!'
		}
	},
	instructions: {
		editRoles: {
			0: 'Replacement Stock Arrived - Set New Appointment'
		},
		viewRoles: {
			0: 'Replacement Stock Arrived'
		}
	},
	startNode: 'ReplacementStockArrivedNotification',
	nodes: {
		ReplacementStockArrivedNotification: {
			initFormFields: bf => {
				bf.addControl('new_state', new UntypedFormControl('--'));
			},
			serverCalls: {
				keyValueList: {
					errorMessage: 'No job data could be retrieved',
					directCall: (http, store) => {
						return store
							.select(getFullItemTwo)
							.pipe(
								skipWhile(x => !x),
								take(1),
								map(res => res as any)
							)
							.pipe(
								map(itemTwo => {
									console.log('ITEM TWO ', itemTwo);
									const produc = itemTwo?.claim?.loan_information?.voucher_type ?? 'No voucher type';
									const list = {
										Product: `${produc}`,
										'Claim Type : ': itemTwo?.claim?.type ?? '',
										'Client : ': itemTwo?.claim?.applicant ? `${itemTwo?.claim?.applicant?.first_name} ${itemTwo?.claim?.applicant?.surname}` : '',
										'Contact Number : ': itemTwo?.claim?.applicant?.contact_number ?? '',
										'Cell Number : ': itemTwo?.claim?.loan_information?.cellnumber ?? '',
										'Address : ': itemTwo?.address ?? ''
									};
									return [list];
								})
							);
					}
				}
			},
			inputs: {
				title: 'Replacement Stock Arrived - Set New Appointment',
				instructions: ['The customer has indicated that the replacement arrived.', 'Phone the customer to set new appointment']
			},
			component: {
				children: [
					{
						component: 'FLXHeadingWithInstructionsComponent',
						inputs: {
							title: 'Replacement Stock Arrived - Set New Appointment',
							instructions: ['The customer has indicated that the replacement arrived.', 'Phone the customer to set new appointment']
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: {
							data$: 'keyValueList'
						}
					}
				]
			},
			navs: [
				{
					text: 'set appointment',
					nextNode: 'SetAppointment',
					color: 'primary'
				}
			]
		},
		SetAppointment: {
			inputs: {
				minDate: new Date()
			},
			checkValidityForFields: ['appointmentData'],
			initFormFields: (bf, item, instance, sq) => {
				bf.addControl(
					'appointmentData',
					new UntypedFormGroup({
						appointmentDatePicker: new UntypedFormControl(null, Validators.required),
						appointmentTime: new UntypedFormControl(null, Validators.required),
						appointmentTimePicker: new UntypedFormControl(null, Validators.required),
						appointmentDateType: new UntypedFormControl(null, Validators.required),
						skill: new UntypedFormControl('Dish Installation')
					})
				);
				bf.patchValues({
					appointmentData: bf.getControl('appointmentData')?.value || ''
				});
				bf.patchValues({ new_state: 22 });
			},
			serverCalls: {
				claimaintKeyValues: {
					errorMessage: 'Claimant detail could not be retrieved',
					directCall: (_http: HttpClient, _store: Store, _sq: any, _bf) => {
						return _store
							.select(getFullItemTwo)
							.pipe(
								skipWhile((x: any) => !x),
								take(1),
								map(res => res as any)
							)
							.pipe(
								map(job => {
									const claimantinfo = {
										'Claimant Details ': {
											'Full name ': `${job.claim?.applicant?.first_name} ` + `${job.claim?.applicant?.surname}`,
											'Contact Number': job?.claim?.loan_information.ContactNumber,
											'Mobile Number ': job?.claim?.loan_information.cellnumber,
											'On-site contact name ': job?.claim?.loan_information.onsiteperson
										}
									};
									return [claimantinfo];
								})
							);
					}
				},
				customer_details: {
					errorMessage: 'No customer details were found!',
					directCall: (http, store, sq) => {
						return sq
							.queryObject(
								gql`
									{
										fullItemTwo {
											claim {
												applicant {
													first_name
													surname
													contact_number
												}
												loan_information {
													onsitecontact
												}
											}
										}
									}
								`,
								store.select(getFullItemTwo).pipe(
									skipWhile(fi => !fi),
									take(1),
									map(res => ({ fullItemTwo: res }))
								)
							)
							.pipe(
								map((qdat: any) => {
									return [
										{
											'Client Name': `${qdat.first_name} ${qdat.surname}`
										},
										{ 'Contact Number': `${qdat.contact_number}` },
										{ 'Mobile Number': `${qdat.onsitecontact}` }
									];
								})
							);
					}
				},
				onsite_details: {
					errorMessage: 'Onsite details not found!',
					directCall: (http, store, sq, bf) => {
						return sq
							.queryObject(
								gql`
									{
										fullItemTwo {
											claim {
												loan_information {
													onsiteperson
													onsitecontact
												}
											}
										}
									}
								`,
								store.select(getFullItemTwo).pipe(
									skipWhile(f => !f),
									take(1),
									map(res => ({ fullItemTwo: res }))
								)
							)
							.pipe(
								map((queryData: any) => {
									return [{ 'Onsite Contact Name': `${queryData.onsiteperson}` }, { 'Onsite Contact Number': `${queryData.onsitecontact}` }];
								})
							);
					}
				},
				appointmentTypes: {
					serviceVariable: 'service',
					functionName: 'getAppointmentTypes',
					errorMessage: 'No Appointment Types could be found!'
				}
			},
			navs: [
				{
					text: 'Set Appointment',
					optIntoValidation: true,
					linkType: 'portal',
					color: 'primary',
					nextNode: 'SubmissionSuccess',
					serverFirst: true,
					serverCalls: {
						response: {
							errorMessage: 'Appointment not set!',
							directCall: (http, store, sq, bf) => {
								return forkJoin([
									store.select(getFullItemTwo).pipe(
										skipWhile(x => !x),
										take(1)
									),
									store.select(getSubmissionData).pipe(
										skipWhile(x => !x),
										take(1)
									)
								]).pipe(
									map(([job, submit]) => {
										const job_id = job?.id;
										const current_state = job?.state;
										const appointment = submit.appointment;
										const data = {
											job_id: job_id,
											current_state: current_state,
											appointment: appointment,
											new_state: 22
										};
										return data;
									}),
									switchMap(data => {
										return http.post(`${environment.api_url}v1/job_action/update_job/`, data);
									})
								);
							}
						}
					}
				}
			],
			component: 'FLXJobAppointmentComponent'
		},
		SubmissionSuccess: { component: 'FLXSuccessTickComponent' }
	},
	bigFormToStoreMapper: {
		new_state: 'new_state',
		appointmentData: [
			appointment => {
				if (appointment && appointment.appointmentDatePicker && appointment.appointmentTimePicker) {
					const date = moment(appointment.appointmentDatePicker);
					date.hour(appointment.appointmentTimePicker.hour);
					date.minutes(appointment.appointmentTimePicker.minutes);
					const date_formatted = date.format('YYYY-MM-DDTHH:mm:ss');
					return {
						range_start: date_formatted,
						range_end: date_formatted,
						appointment_type: appointment.appointmentTime
					};
				}
			},
			'appointment'
		]
	}
};
